import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ConfirmationRequestPageBase } from '@bo-client/shared/base-components/confirmation-request-page.base';
import { RequestFormBase } from '@bo-client/shared/base-components/request-form.base';
import { uri } from '@bo-client/shared/constants/uri';
import { RequestApprovalDto } from '@bo-client/activation-management/grid-registration/model/RequestApprovalDto';
import { Subject } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpHapService } from '@bo-client/core/http/http-hap.service';
import { ToastrService } from 'ngx-toastr';
import { DataShareService } from '@bo-client/shared/services/data-share.service';
import { ConfigService } from '@bo-client/config/config.service';
import { AuthenticationService } from '@bo-client/core';
import { GridRegistrationModel } from '@bo-client/activation-management/grid-registration/model/grid-registration.model';
import { GridRegistrationRequestService } from '@bo-client/activation-management/grid-registration/grid-registration-request.service';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-gr-confirm-feedin-order',
  templateUrl: './gr-confirm-feedin-order.component.html',
  styleUrls: ['./gr-confirm-feedin-order.component.scss']
})
export class GrConfirmFeedinOrderComponent
  extends ConfirmationRequestPageBase<GridRegistrationModel>
  implements OnInit, OnDestroy
{
  @ViewChild('form')
  public form: RequestFormBase<GridRegistrationModel>;
  public uriGetData = uri.cmGridRegistrationRequestExternal;
  public requestApprovalDto: RequestApprovalDto;
  public compUnsubs$ = new Subject<void>();
  public actions = this.gridRegistrationRequestService.actions;

  public gridRegistration: GridRegistrationModel = null;

  constructor(
    protected route: ActivatedRoute,
    protected router: Router,
    protected httpService: HttpHapService,
    protected toastService: ToastrService,
    protected matDialog: MatDialog,
    protected gridRegistrationRequestService: GridRegistrationRequestService,
    private dataShareService: DataShareService,
    private configService: ConfigService,
    private authenticationService: AuthenticationService
  ) {
    super(route, router, httpService, toastService, matDialog);
    this.title = 'Einspeisemanagement Vertrag Anfrage für Kunden';
  }

  ngOnInit() {
    super.init();
  }

  hookDataLoaded() {
    console.log('not sure how this shou.d be triggered', this.model);
    // entry Point after standard loading data
    this.gridRegistration = this.model;
  }

  hookGetDataFromForm() {
    // entry Point to modify additionalData to save
    // in base Component additionaldata is loaded with the form structure
    // this.requestApprovalDto.additionalData = {....}
  }

  generateDocument() {
    const serverUrl = this.configService.getSettings('serverUrl');

    const url = `${serverUrl}/print/external/feederContract?feederContractId=${this.model.id}&feederContractToken=${this.model.token}&tenant=${this.dataShareService.selectedTenant.id}&access_token=${this.authenticationService.credentials.token}&template=TM_GRID_REGISTRATION_ORDER_CONFIRMATION&targetType=application/pdf`;

    window.open(url, '_blank');
  }

  ngOnDestroy() {
    this.compUnsubs$.next();
    this.compUnsubs$.complete();
  }
}
